module.exports = "/images/283713e8a73e7bef58290ac5fc9cbf76.jpg";